import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import { setTheme } from '../store/slices/uiSlice';

export const useTheme = () => {
    const dispatch = useAppDispatch();
    const { theme } = useAppSelector((state) => state.ui);

    // Применяем тему к корневому элементу
    useEffect(() => {
        const root = document.documentElement;

        // Удаляем все классы тем
        root.classList.remove('light-theme', 'dark-theme');

        // Добавляем класс текущей темы
        root.classList.add(`${theme}-theme`);

        console.log('🎨 Применена тема:', theme);
    }, [theme]);

    // Восстановление после разблокировки
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                console.log('🎨 Восстановление темы после разблокировки:', theme);

                const root = document.documentElement;
                root.classList.remove('light-theme', 'dark-theme');
                root.classList.add(`${theme}-theme`);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [theme]);

    return {
        theme,
        toggleTheme: () => {
            const newTheme = theme === 'light' ? 'dark' : 'light';
            console.log('🎨 Переключение темы на:', newTheme);
            dispatch(setTheme(newTheme));
        }
    };
};